import React from "react"
import { Prompt as RouterPrompt } from "react-router-dom"
import PropTypes from "prop-types"

const Prompt = ({ message, when }) => (
  <RouterPrompt when={when} message={message} />
)

Prompt.propTypes = {
  message: PropTypes.string,
  when: PropTypes.bool.isRequired
}

Prompt.defaultProps = {
  message: "You will lose your changes. Are you sure?",
  when: false
}

export default Prompt
